import { Avatar, Button, Space } from "antd";
import { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import AVATAR_IMG from "../../../../assets/images/empty_user.jpg";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import Loader from "../../../../components/ui/Loader";
import { useGetAllGroupByUserIdQuery } from "../../../../features/administrative-setting/administrativeSetting";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import UserDetailsLog from "./_components/UserDetailsLog";

const backLink = "/admin/user-access-permission/user-list";

export default function UserDetailsPermission() {
  const { id } = useParams();
  const {
    data: groupData,
    isLoading: isGroupLoading,
    isError: isGroupError,
    error: groupError,
  } = useGetAllGroupByUserIdQuery(
    {
      params: { id: Number(id) },
    },
    {
      skip: !id,
    }
  );
  useError(isGroupError, groupError, "Get group data fail");

  const userDetails = groupData?.data?.user;
  const groupPermissions = groupData?.data?.groupPermissions;

  return (
    <SidebarLayout title="User Details and Logs">
      {isGroupLoading ? (
        <Loader />
      ) : (
        <CustomCard className="p-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <CardTitle>User Info</CardTitle>

              <div className="flex items-center gap-4 min-h-[150px]">
                <Avatar
                  className="w-24 h-24 rounded-full"
                  src={userDetails?.photo || AVATAR_IMG}
                />

                <div className="flex-1">
                  <h5 className="text-slate-700 text-lg font-semibold leading-8">
                    {userDetails?.name}
                  </h5>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    {userDetails?.sub_department?.name}
                  </p>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    Department of{" "}
                    <span className="text-yellow-500">
                      {userDetails?.department?.name}
                    </span>
                  </p>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    Email:{" "}
                    <a
                      href={`mailto:${userDetails?.email}`}
                      className="!text-accent"
                    >
                      {userDetails?.email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <CardTitle>Assigned Role</CardTitle>

              <div className="grid grid-cols-12 gap-x-4 gap-y-2 mt-4">
                {groupPermissions?.map((el) => (
                  <Fragment key={el?.id}>
                    <div className="text-blue-600 text-sm font-medium leading-6 col-span-4">
                      {el?.product?.name}
                    </div>
                    <div className="text-zinc-700 text-sm font-medium leading-6  col-span-8">
                      {el?.groupName}
                    </div>
                    {/* <div className="flex items-center">
                      <Button
                        type="text"
                        className="!p-0 !size-8 flex justify-center items-center !text-red-500"
                        htmlType="button"
                        //   onClick={() => handleEdit(el, idx)}
                      >
                        <DeleteIcon />
                      </Button>
                    </div> */}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>

          <UserDetailsLog />

          <Space className="w-full mt-4" size={12}>
            <Link to={backLink}>
              <Button className="normal-dark-button modal-button" size="middle">
                Cancel
              </Button>
            </Link>
            <Link to={`/admin/user-access-permission/user-list/edit/${id}`}>
              <Button className="modal-button" type="primary" size="middle">
                Edit
              </Button>
            </Link>
          </Space>
        </CustomCard>
      )}
    </SidebarLayout>
  );
}
